// BL-877 — registry entries for the sales-rep roster (ADR 027).
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
// Type-only import (erased at build) — keeps the registry client-bundle-safe.
import type { SalesRepArchiveCheckDto, SalesRepDto } from '../../schemas/responses/sales-rep';

export const sales_reps = {
  index: defineAdminRoute({
    path: '/api/sales-reps',
    params: {},
    methods: {
      // GET lists the tenant's ACTIVE roster; POST returns the created rep.
      // BL-1833: read by the rep pickers — the item form (Cataloger) and the
      // customer SalesRepCard (Admin); written only from Settings → Team.
      // BL-2525: and the settlement page's Sales rep picker (Accounting).
      GET: {
        grant: { anyOf: ['inventory.read', 'customer.update', 'settlement.update'] },
        tenant: { from: 'input', field: 'tenantId', in: 'query' },
        response: responseType<SalesRepDto[]>(),
        query: { tenantId: '' },
      },
      POST: { grant: 'staff.update', tenant: { from: 'input', field: 'tenantId', in: 'query' }, response: responseType<SalesRepDto>() },
    },
  }),
  detail: defineAdminRoute({
    path: '/api/sales-reps/:id',
    params: { id: '' },
    // PUT returns the updated rep; DELETE archives and returns no data payload,
    // so it carries no response marker.
    methods: {
      PUT: {
        grant: 'staff.update',
        tenant: { from: 'record', table: 'sales_rep', param: 'id' },
        response: responseType<SalesRepDto>(),
      },
      DELETE: { grant: 'staff.update', tenant: { from: 'record', table: 'sales_rep', param: 'id' } },
    },
  }),
  // BUG-2129: the archive dialog's read on open — how many live lots still list
  // the rep as a contact. Same grant and tenant as the DELETE it precedes.
  archive_check: defineAdminRoute({
    path: '/api/sales-reps/:id/archive-check',
    params: { id: '' },
    methods: {
      GET: {
        grant: 'staff.update',
        tenant: { from: 'record', table: 'sales_rep', param: 'id' },
        response: responseType<SalesRepArchiveCheckDto>(),
      },
    },
  }),
};
